import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
    const isAuthented = useSelector(state => state.sessionReducer.isAuthented);
    return (
        isAuthented ?
            <Outlet />
            : <Navigate to="/page-404" />
    );
};

export default PrivateRoute;
